'use strict';

angular.module('docketbook').
  controller('recommendLineItemResourceModalController', function (addressBookService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q, uuid, docketService) {

    $scope.loading = false;
    $scope.resources = [];
    $scope.lineItem = {};

    $scope.acceptCb = null;
    $scope.continueToSearchCb = null;
    $scope.selectedResources = [];

    $scope.$parent.showRecommendLineItemResourceModal = function (lineItem, resources, acceptCb, continueToSearchCb) {
      $scope.resources = resources;

      if (resources.length == 1) {
        $scope.selectedResources = resources;
      }
      $scope.lineItem = lineItem;
      $scope.acceptCb = acceptCb;
      $scope.continueToSearchCb = continueToSearchCb;

      $('#recommendLineItemResourceModal').fadeIn(100);
    }

    $scope.continueToSearch = function () {
      $('#recommendLineItemResourceModal').fadeOut(100);
      $scope.continueToSearchCb();
    }

    $scope.close = function () {
      $('#recommendLineItemResourceModal').fadeOut(100);
    }

    $scope.addResource = function () {
      $('#recommendLineItemResourceModal').fadeOut(100);

      $scope.acceptCb($scope.selectedResources[0]);
    }
  })



// WEBPACK FOOTER //
// ./src/controllers/modals/recommendLineItemResourceModalController.js